import mdParser from '~/features/mdParser';
import privacyConsent from '~/features/privacyConsent';
import { parseJwt } from '../store/authStore';

const getLayoutForResourceType = (type) => {
    switch (type) {
        case 'post':
            return 'empty';
        case 'campaignContribution':
            return 'empty';
        default:
            return 'default';
    }
};

export default async (context) => {
    if (context.query.injectedToken) {
        await context.store.dispatch('authStore/injectLogin', { token: context.query.injectedToken });
    }

    if (context.route.fullPath.startsWith('/dashboard') && !context.app.$auth.loggedIn) {
        return context.redirect('/login');
    }

    // show cookies on client if needed
    if (process.client) {
        context.store.commit('app/setShowCookiesBanner', !privacyConsent.hasConsentBeenGiven());
    }

    // check if logged in and fetch user's profile
    if (context.app.$auth.loggedIn) {
        try {
            if (context.store.getters['profile/getMyProfile'] === null) {
                const token = context.app.$auth.strategy.token.get();
                const parsedToken = parseJwt(token);

                if (parsedToken['custom:profile_id']) {
                    if (!context.route.fullPath.startsWith('/profile/deleted') && !context.route.fullPath.startsWith('/logout')) {
                        await context.store.dispatch('profile/fetchMyProfile');
                    }
                } else if (!context.route.fullPath.startsWith('/logout') && !context.route.fullPath.startsWith('/profile/create') && !context.route.fullPath.startsWith('/profile/delete')) {
                    return context.redirect('/profile/create');
                }
            }
        } catch (e) {
            console.error(e);
        }
    }

    const profile = context.store.getters['profile/getMyProfile'];
    if (profile && profile.language) {
        const translationMatch = context.i18n.locales.filter((locale) => locale.iso.toLowerCase() === profile.language.toLowerCase());
        if (translationMatch && translationMatch.length > 0) {
            await context.i18n.setLocale(translationMatch[0].code);
        }
    }

    // Note: don't use the runtime hostname; this server runs under the API gateway hostname when deployed :(
    const fullyQualifiedURL = `https://${context.$config.webAppDomain}${context.route.fullPath}`;

    await context.store.commit('app/updateFullyQualifiedURL', fullyQualifiedURL);
    let url = context.params.pathMatch;
    if (url === undefined) {
        return;
    }

    let content = mdParser(url);
    if (content !== null) {
        context.layout = 'default';
        context.data = {
            type: 'static',
            content: content,
            url: url,
        };
        return;
    }

    if (Object.keys(context.query).length > 0) {
        const queryParams = new URLSearchParams(context.query);
        url += '?' + queryParams.toString();
    }

    await context.store.commit('ui/showLoader', 'resource');
    await context.store.dispatch('resource/fetch', { url, path: context.params.pathMatch, fetchFullTranscripts: true });
    const resource = context.store.getters['resource/getByUrl'](context.params.pathMatch);

    if (resource.permanentRedirect) {
        context.redirect(301, `https://${context.$config.webAppDomain}/${resource.permanentRedirect}`);
    } else if (resource.error) {
        const error = resource.error;
        const isForbidden = error.message.indexOf('403') !== -1;
        const is404 = error.message.indexOf('404') !== -1;
        if (isForbidden && context.app.$auth.loggedIn === false) {
            console.error('forbidden');
        }

        context.layout = 'default';
        if (!context.res) {
            context.res = {};
        }

        if (isForbidden) {
            context.res.statusCode = 403;
            context.data = {
                type: 'error403',
            };
        } else if (is404) {
            context.res.statusCode = 404;
            context.data = {
                type: 'error404',
            };
        } else {
            context.res.statusCode = 500;
            context.data = {
                type: 'error500',
            };
        }
    } else {
        const resourceType = resource.type;
        context.layout = getLayoutForResourceType(resourceType);
        context.data = {
            type: 'resource',
        };

        switch (resourceType) {
            case 'profile':
                context.redirect('/');
                break;
            case 'post':
            case 'campaignContribution':
                break;
            default:
                console.error(`Unsupported resource type ${resourceType}`);
        }
    }
};
